package ru.villawonka.app.presentation.screens.settings.viewmodel

import ru.villawonka.app.common.mvvm.SingleLiveEvent
import ru.villawonka.app.presentation.model.CountryUIModel
import ru.villawonka.app.presentation.model.CurrencyUIModel
import ru.villawonka.app.presentation.model.LanguageUIModel

sealed interface SettingsUIEvent : SingleLiveEvent {

    data class OpenLanguagePicker(
        val selectedItem: LanguageUIModel?,
        val items: List<LanguageUIModel>
    ) : SettingsUIEvent

    data class OpenCountryPicker(
        val selectedItem: CountryUIModel?,
        val items: List<CountryUIModel>
    ) : SettingsUIEvent

    data class OpenCurrencyPicker(
        val selectedItem: CurrencyUIModel?,
        val items: List<CurrencyUIModel>
    ) : SettingsUIEvent

    data object OpenServiceNews : SettingsUIEvent

    data object OpenContactSupport : SettingsUIEvent

    data object OpenPrivacyPolicy : SettingsUIEvent

    data object OpenTermsOfUse : SettingsUIEvent
}